<div
  (click)="handleClickOnTagger($event)"
  [class.disabled]="disabled"
  [class.readonly]="readOnly"
  [class.has-error]="hasInvalidTags"
  [class.has-focus]="hasFocusActive && applyStyleOnFocus"
  class="tagger__tags"
>
  <rt-typeahead
    #taggerTypeahead="rtTypeahead"
    [minLength]="1"
    [suggestions]="typeaheadSuggestions"
    [suggestionsDropdownTpl]="typeaheadSuggestionsTemplate"
    (changed)="typeaheadChanged.emit($event)"
    (selected)="selectedWithTypeahead($any($event))"
  >
    @for (tag of tags; track trackByTag(index, tag); let index = $index) {
      <rt-button
        variant="outline"
        size="small"
        #tagButton
        [title]="tagTitleFn(tag)"
        [class]="'tagger__tag tagger__tag--' + tagTypeFn(tag)"
        rt-overlay-origin
        [pressed]="selectEmailDropdown.open"
        [class.hasDropdown]="hasDropdown(tag, index)"
        [class.invalid]="markInvalid && !tag.isValid"
        #selectEmailDropdownTrigger="rtOverlayOrigin"
        (click)="hasDropdown(tag, index) && toggleDropdown(selectEmailDropdown)"
      >
        <ng-template
          [ngTemplateOutlet]="singleTagTemplate || defaultTemplate"
          [ngTemplateOutletContext]="{ tag: tag }"
        />
        @if (!disabled && !readOnly) {
          <rt-icon-button
            size="small"
            (click)="deleteTag(tag, index); $event.stopPropagation()"
            variant="plain"
            class="tagger__close"
            iconName="close"
            shape="square"
          />
        }
        @if (hasDropdown(tag, index)) {
          <rt-icon [name]="selectEmailDropdown.open ? 'arrow-drop-up' : 'arrow-drop-down'" />
        }
        <ng-template
          #selectEmailDropdown="rtConnectedOverlay"
          rt-connected-overlay
          [hasBackdrop]="true"
          [width]="300"
          [positions]="dropdownConfig"
          [origin]="selectEmailDropdownTrigger"
          (backdropClick)="toggleDropdown(selectEmailDropdown, false)"
        >
          @if (dropdownTemplate && hasDropdown(tag, index)) {
            <ng-container
              [ngTemplateOutletContext]="{
                hostComponent: this,
                tag: $any(tags[index]),
                index: index,
                selectCandidate: selectCandidate,
                selectEmailDropdown: selectEmailDropdown,
                openCandidate: openCandidate,
              }"
              [ngTemplateOutlet]="dropdownTemplate"
            />
          }
        </ng-template>
      </rt-button>
    }

    <rt-input
      #input
      class="tagger__input"
      variant="rounded"
      rtTypeaheadInput
      [placeholder]="placeholder"
      [formControl]="dummyInputControl"
      (keydown)="onKeyDown($event)"
      (keyup)="onInput()"
      (blur)="onBlur()"
      (focus)="onFocus()"
    />
  </rt-typeahead>

  <ng-template
    #typeaheadSuggestionsTemplate
    let-typeaheadstate="typeaheadstate"
    [ngTemplateType]="SuggestionsContext"
  >
    <ng-template
      [ngTemplateOutlet]="suggestionsTemplate"
      [ngTemplateOutletContext]="{ state: typeaheadstate, typeahead: taggerTypeahead }"
    />
  </ng-template>
</div>

<ng-template #defaultSingleTagTemplate let-tag="tag">
  {{ tag }}
</ng-template>

<ng-template #emailSingleTagTemplate let-tag="tag">
  @if ((!selectCandidate && tag.candidate) || tag.admin) {
    <span [rtTooltip]="tag.email" class="tag__name-container">
      <span class="tag__name">
        <rt-truncate>{{ tag.name }}</rt-truncate>
      </span>
    </span>
  }

  @if (!selectCandidate && !tag.candidate && !tag.admin) {
    <span>
      <span>{{ tag.email }}</span>
    </span>
  }

  @if (selectCandidate) {
    <span>
      <span>{{ tag.email }}</span>
    </span>
  }
</ng-template>

<ng-template
  #defaultSuggestionsTemplate
  let-state="state"
  let-typeahead="typeahead"
  [ngTemplateType]="DefaultTypeaheadSuggestionsContext"
>
  @if (state.suggestions.length > 0) {
    <rt-typeahead-suggestions
      [stateName]="state.name"
      [stateValue]="state.value"
      [suggestions]="state.suggestions"
      [highlighted]="state.highlighted!"
      (suggestionSelect)="typeahead.select($event)"
      (mousedown)="$event.stopImmediatePropagation(); $event.preventDefault()"
    />
  }
</ng-template>

<ng-template
  #emailSuggestionsTemplate
  let-state="state"
  let-typeahead="typeahead"
  [ngTemplateType]="EmailTypeaheadSuggestionsContext"
>
  @if (state.suggestions.length > 0) {
    <div class="email-typeahead-suggestions">
      <rt-dropdown>
        <div (mousedown)="$event.stopImmediatePropagation(); $event.preventDefault()">
          @for (suggestion of state.suggestions; track trackBySuggestion($index, suggestion)) {
            <rt-dropdown-item
              (click)="typeahead.select(suggestion)"
              [highlighted]="state.highlighted === suggestion.id"
            >
              {{ suggestion.emailObject.name }} ({{ suggestion.emailObject.email }})
            </rt-dropdown-item>
          }
        </div>
      </rt-dropdown>
    </div>
  }
</ng-template>
